import {useCostCalculation} from "@src/customFunctions/СostСalculation";
import {FC} from "react";

type CostCalculatorProps = {
    vehicleType: string,
}

export const CostCalculator: FC<CostCalculatorProps> = ({vehicleType}) => {
    useCostCalculation(vehicleType);
    return null;
};
